import { useLocationStore } from '@/store/location'

/**
 * Custom URL schemes the native iOS app intercepts to foreground itself when the in-app
 * web checkout runs in EXTERNAL Safari (a separate app). Opening one of these hrefs is the
 * only way to hand the user back to the native app.
 *
 * - success  → app picks up the subscription (already shipped, format must NOT change).
 * - cancel   → native paywall dismisses the web checkout.
 *
 * ⚠️ WEB_CHECKOUT_CANCELLED_DEEPLINK host is PRELIMINARY — confirm the exact host name with
 *    iOS (Sergei / DEV-33030) before merging. It lives in one place so it changes in one place.
 */
export const PURCHASE_CALLBACK_DEEPLINK = 'fstr://purchase_callback'
export const WEB_CHECKOUT_CANCELLED_DEEPLINK = 'fstr://web_checkout_cancelled'

export function useInAppReturnDeeplinks() {
	const locationStore = useLocationStore()

	// `source`/`offer` come from the original /redirect URL. getQueryParam reads the bootstrap
	// snapshot of window.location.search, so they survive client-side navigation through the
	// checkout to the success screen — no extra threading needed.
	const getSource = () => locationStore.getQueryParam('source') ?? 'onboarding'
	const getOffer = () => locationStore.getQueryParam('offer')

	// Keep the EXACT existing success format (do not reorder/encode params differently).
	const buildPurchaseCallbackUrl = ({ price, currency, durationMonth, productID }) =>
		`${PURCHASE_CALLBACK_DEEPLINK}?price=${price}&currency=${currency}&durationMonth=${durationMonth}&productID=${productID}&source=${getSource()}&offer=${getOffer()}`

	const buildCancelUrl = () => `${WEB_CHECKOUT_CANCELLED_DEEPLINK}?source=${getSource()}&offer=${getOffer()}`

	const returnToApp = (url) => {
		window.location.href = url
	}

	return { buildPurchaseCallbackUrl, buildCancelUrl, returnToApp }
}
